import "@arco-design/web-react/es/Select/style";
import _Select from "@arco-design/web-react/es/Select";
import { useSelect as useProject } from '@/pages/project/api';
import React from 'react';
export const SelectProject = ({
  value,
  onChange,
  settleType,
  mode,
  placeholder = '全部'
}) => {
  const {
    data,
    isLoading
  } = useProject({
    params: {
      pageSize: 100,
      pageIndex: 1
    }
  });
  let items = data?.data.items ?? [];

  if (settleType) {
    items = items.filter(v => v.settle_type === settleType);
  }

  return /*#__PURE__*/React.createElement(_Select, {
    mode: mode,
    value: value,
    onChange: onChange,
    placeholder: placeholder,
    loading: isLoading,
    options: items.map(v => ({
      label: `${v.id}:${v.name}`,
      value: v.id
    })),
    allowClear: true
  });
};